module.exports = __webpack_public_path__ + "static/img/1-1.834831c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/1-1.png
// module id = dk7s
// module chunks = 0